import { Container, Row, Col, Form, Button, Spinner, Alert, InputGroup } from "react-bootstrap";
import { useEffect, useState } from "react";

import { AiFillChrome } from 'react-icons/ai'
import { AiFillEyeInvisible, AiFillEye } from 'react-icons/ai'
import Logo from '../assets/logo.png'
import API from '../api/api'
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Actions from "../redux/actions";
import { useSearchParams } from "react-router-dom";
import { BsWindows, BsApple } from 'react-icons/bs'

const useCustomSearchParams = () => {
    const [search, setSearch] = useSearchParams();
    const searchAsObject = Object.fromEntries(
        new URLSearchParams(search)
    );
    return [searchAsObject, setSearch];
};

export default function ForgotPass(props) {


    const [user, setUser] = useState('')
    const [pw, setPw] = useState('')
    const [confirmPw, setConfirmPw] = useState('')
    const [search, setSearch] = useCustomSearchParams()
    const [loading, setLoading] = useState(true)
    const [submitLoading, setSubmitLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [token, setToken] = useState('')
    const [err, setErr] = useState('')
    const [pwErr, setPwErr] = useState('')
    const [newUser, setNewUser] = useState(false)
    const [showPw, setShowPw] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        _checkValid()
    }, [])


    const _checkValid = async () => {
        if (!search.token) {
            setLoading(false)
            setErr('This is not a valid reset link')
        }
        const data = await API.checkValidReset(search.token)
        if (data.isValid) {
        } else {
            setErr('This is not a valid reset link')
        }
        setLoading(false)

    }
    const _resetPw = async (e) => {
        e.preventDefault()
        setPwErr('')
        if (confirmPw !== pw) {
            setPwErr('Passwords do not match')
            return
        }
        if (!/(?=^.{8,}$)(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^A-Za-z0-9]).*/.test(pw)) {
            setPwErr('Passwords must be at least 8 characters long, contain 1 uppercase character, 1 lowercase character, 1 number, and 1 special character')
            return
        }
        setSubmitLoading(true)
        const res = await API.resetPassword(search.token, pw)
        if (res.isError) {
            setPwErr('Something went wrong')
        } else {
            setSuccess(true)
            setNewUser(res.newUser)
        }
        setSubmitLoading(false)
    }


    return (

        <Container className='p-4 text-center'>
            <Row>
                <Col md={6} className='border shadow-lg rounded mx-auto p-4'>
                    <Row>
                        <Col md={5} className='mx-auto'>
                            <img src={Logo} className='img-fluid' alt='logo' />
                        </Col>
                    </Row>
                    {err === '' && !loading && !success && <Row>
                        <Col md={7} className='mx-auto'>
                            <h2>Reset Password</h2>
                            <Form className='mt-4' onSubmit={_resetPw}>
                                <Form.Group className="mb-3 text-start" >
                                    <Form.Label className='text-start'>Password</Form.Label>

                                    <InputGroup className="mb-3">
                                        <Form.Control required type={!showPw ? "password" : 'text'} placeholder="Password" value={pw} onChange={e => setPw(e.target.value)} />
                                        <InputGroup.Text>{showPw ? <AiFillEye className='pointer' onClick={() => setShowPw(!showPw)} /> : <AiFillEyeInvisible className='pointer' onClick={() => setShowPw(!showPw)} />}</InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                                <Form.Group className="mb-3 text-start" >
                                    <Form.Label className='text-start'>Confirm Password</Form.Label>
                                    <InputGroup className="mb-3">
                                        <Form.Control required type={!showConfirm ? "password" : 'text'} placeholder="Password" value={confirmPw} onChange={e => setConfirmPw(e.target.value)} />
                                        <InputGroup.Text>{showConfirm ? <AiFillEye className='pointer' onClick={() => setShowConfirm(!showConfirm)} /> : <AiFillEyeInvisible className='pointer' onClick={() => setShowConfirm(!showConfirm)} />}</InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>

                                <Button type='submit' variant='primary px-5' disabled={loading || !pw || !confirmPw}>Reset Password</Button>
                                {submitLoading && <div className='text-center mt-2'>
                                    <Spinner animation="border" />
                                </div>}
                                {pwErr !== '' && <Alert variant='danger p-2 mt-2'>{pwErr}</Alert>}

                                <br />

                            </Form>
                        </Col>
                    </Row>}
                    {success && <>
                        {!newUser && <Button onClick={() => navigate('/login')}>Back to Login</Button>}
                        <Alert variant='success p-2 m-2'>Your new password has been set.</Alert>

                        {newUser && <>
                            <p className='px-4'>Great job getting your account setup! Add ScamWall to Chrome by clicking the "Add Chrome Extension" button below and then sign in to your account. Watch the tutorial below if you need help.  </p>
                        </>}
                        <a className='btn btn-primary my-2 mb-4' target='__blank' href='https://chrome.google.com/webstore/detail/scamwall/pjkegbkgamcijobfjmpbljhbolejfnip'><AiFillChrome /> Add Chrome Extension</a>
                        <Row className='justify-content-center'>

                            <Col md={8}>

                                <div
                                    class="border rounded iframe-outer"
                                >
                                    <iframe
                                        src="https://player.vimeo.com/video/743708742?h=ca47d3d407&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0"
                                        allow="autoplay; fullscreen; picture-in-picture"
                                        allowfullscreen
                                        className='iframe-inner'
                                        title="ScamWall Tutorial"
                                    ></iframe>
                                </div>
                            </Col>
                        </Row>
                    </>}
                    {loading && <div className='text-center mt-2'>
                        <Spinner animation="border" />
                    </div>}
                    {err !== '' && <Alert variant='danger p-2 mt-2'>{err}</Alert>}

                </Col>
            </Row>
        </Container>
    )
}